(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("AvailityReactstrapValidation", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["AvailityReactstrapValidation"] = factory(require("react"), require("react-dom"));
	else
		root["AvailityReactstrapValidation"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_246__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition